import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = "ff:cookie-consent";

function hasConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY) === "granted";
  } catch {
    return false;
  }
}

function loadGa() {
  if (!GA_ID || window.__gaLoaded) return;
  window.__gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    anonymize_ip: true,
    cookie_flags: "SameSite=None;Secure",
  });
}

export default function Analytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!GA_ID) return;
    if (hasConsent()) loadGa();
    // Listen for consent granted while page is open
    const handler = () => hasConsent() && loadGa();
    window.addEventListener("ff:consent-changed", handler);
    return () => window.removeEventListener("ff:consent-changed", handler);
  }, []);

  useEffect(() => {
    if (!GA_ID || !hasConsent() || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
